import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography
} from '@mui/material';

const QuantityReceivedDialog = ({ open, onClose, onConfirm, product }) => {
  const [quantity, setQuantity] = useState('');
  const [error, setError] = useState('');

  // Reset quantity when dialog opens
  useEffect(() => {
    if (open && product) {
      // Imposta la quantità predefinita alla quantità rimanente dell'ordine
      const quantityToReceive = product.quantity - (product.receivedQuantity || 0);
      setQuantity(quantityToReceive.toString());
      setError('');
    }
  }, [open, product]);

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    // Allow only positive numbers
    if (value === '' || /^[1-9]\d*$/.test(value)) {
      setQuantity(value);
      
      // Validazione quantità massima
      const quantityToReceive = product?.quantity - (product?.receivedQuantity || 0);
      if (parseInt(value) > quantityToReceive) {
        setError(`La quantità non può superare ${quantityToReceive}`);
      } else {
      setError('');
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && quantity && !error) {
      handleConfirm();
    }
  };

  const handleConfirm = () => {
    const quantityNum = parseInt(quantity);
    const quantityToReceive = product?.quantity - (product?.receivedQuantity || 0);
    
    if (quantityNum <= 0) {
      setError('La quantità deve essere maggiore di 0');
      return;
    }
    
    if (quantityNum > quantityToReceive) {
      setError(`La quantità non può superare ${quantityToReceive}`);
      return;
    }
    
    onConfirm(quantityNum);
  };

  // Se non c'è prodotto, non mostra il dialog
  if (!product) return null;
  
  // Determina il nome e il codice del prodotto da visualizzare
  const productName = product.description || (product.existingProduct?.name || product.name || '');
  const productCode = product.code || '';
  const quantityToReceive = product.quantity - (product.receivedQuantity || 0);

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        Ricezione Articolo
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ py: 2 }}>
          <Typography variant="body1" gutterBottom>
            Indica la quantità ricevuta per {productName} ({productCode})
          </Typography>
          
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Quantità ancora da ricevere: {quantityToReceive}
          </Typography>
          
          <TextField
            autoFocus
            margin="dense"
            label="Quantità ricevuta"
            type="number"
            fullWidth
            value={quantity}
            onChange={handleQuantityChange}
            onKeyPress={handleKeyPress}
            error={!!error}
            helperText={error}
            inputProps={{ 
              min: 1,
              max: quantityToReceive,
              'aria-label': 'Quantità ricevuta'
            }}
            sx={{ mt: 2 }}
          />
        </Box>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} color="inherit">
          Annulla
        </Button>
        <Button 
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={!quantity || parseInt(quantity) <= 0 || !!error}
        >
          Conferma
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuantityReceivedDialog; 